import TableRowActions from './table_row_actions';
import TableCell from './table_cell';


const RealizeTableRow = window.TableRow;
// const RealizeTableCell = window.TableCell;

export default class TableRow extends RealizeTableRow { 
	static defaultProps = {
		...RealizeTableRow.defaultProps,
		tableCellComponent: TableCell,
	};

	constructor(props) {
		super(props);
		this.renderCells = TableRow.prototype.renderCells.bind(this);
		this.renderActionsCell = TableRow.prototype.renderActionsCell.bind(this);
	}

	renderActionsCell() {
		return (!Array.isArray(this.props.actionButtons) || this.props.actionButtons.length === 0)
			? <td></td>
			: <TableRowActions {...this.propsWithoutCSS()} ref="actions" className="table-row__actions" />;
	}

	renderCell([columnKey, columnProps]) {
		const { name, tableCellComponent } = columnProps;
		const Component = tableCellComponent || this.props.tableCellComponent;
		const columnName = name || columnKey;

		return (
			<Component
				{...columnProps}
				{...this.propsWithoutCSS()}
				tableRowData={this.props.data}
				name={columnName}
				key={columnName}
			/>
		);
	}

	renderCells() {
		const { columns } = this.props;

		return Object.entries(columns)
			.filter(([columnName, columnProps]) => !!columnProps.visible)
			.map(this.renderCell.bind(this));
	}
}
